import React, { Component } from "react";
import PropTypes from "prop-types";
import { Radio } from "antd";
import DateHistogram from "./charts/date-histogram";

class Dates extends Component {
  static propTypes = {
    filter: PropTypes.object
  };

  state = {
    fieldDate: "priority_date"
  };

  render() {
    return (
      <div style={{ width: "100%" }}>
        <Radio.Group value={this.state.fieldDate} onChange={e => this.setState({ fieldDate: e.target.value })}>
          <Radio.Button value="priority_date">{"Priority Date"}</Radio.Button>
          <Radio.Button value="application_date">{"Filing Date"}</Radio.Button>
          <Radio.Button value="publication_date">{"Publication Date"}</Radio.Button>
          <Radio.Button value="expiration_date">{"Expiration Date"}</Radio.Button>
        </Radio.Group>
        <DateHistogram filter={this.props.filter} fieldDate={this.state.fieldDate} />
      </div>
    );
  }
}

export default Dates;
